<script setup lang="ts">

import {CurrencyDisplay, formatting, Models, useOrderViewContext} from "@hantera/portal-app";
import {computed} from "vue";
import Decimal from "decimal.js";

const props = defineProps<{
  invoiceLine: Models.Graph.InvoiceLine
}>();

const order = useOrderViewContext();

const description = computed(() => {
  if (props.invoiceLine.description) {
    return props.invoiceLine.description;
  }

  if (props.invoiceLine.referenceType === 'delivery')
  {
    return 'Shipping'
  }
  
  return '-'
})

const totalDiscount = computed(() => {
  return props.invoiceLine.discounts.reduce((sum, d) => {
    return sum.add(d.amount)
  }, new Decimal(0))
})

const net = computed(() => {
  // If this order shows prices including tax, then discounts should affect invoice line total
  if (order.state.taxIncluded) {
    return props.invoiceLine.net
  }
  
  // Otherwise we increase the net visually so that we can reduce it by showing the discounts
  return props.invoiceLine.net.add(totalDiscount.value)
})

const total = computed(() => {
  // If this order doesn't show prices including tax, then discounts should affect invoice line net
  if (!order.state.taxIncluded) {
    return props.invoiceLine.net
  }

  // Otherwise we increase the total visually so that we can reduce it by showing the discounts
  return props.invoiceLine.total.add(totalDiscount.value)
})

</script>

<template>
  <div class="invoice-line">
    <div class="invoice-line__cell">
      {{invoiceLine.invoiceLineNumber}}
    </div>
    <div class="invoice-line__cell">
      {{invoiceLine.productNumber}}
    </div>
    <div class="invoice-line__cell invoice-line__description">
      {{description}}
    </div>
    <div class="invoice-line__cell">
      <template v-if="invoiceLine.quantity">{{formatting.number(invoiceLine.quantity)}}</template>
    </div>
    <div class="invoice-line__cell">
      {{formatting.currency(invoiceLine.net, order.state.currencyCode, CurrencyDisplay.none)}}
    </div>
    <div class="invoice-line__cell">
      {{formatting.currency(invoiceLine.tax, order.state.currencyCode, CurrencyDisplay.none)}}
    </div>
    <div class="invoice-line__cell">
      {{formatting.currency(invoiceLine.total, order.state.currencyCode, CurrencyDisplay.none)}}
    </div>
    
    <div
      v-for="discount in invoiceLine.discounts"
      :key="discount.invoiceLineDiscountId"
      class="invoice-line__discount"
    >
      <div class="invoice-line__cell">
        {{discount.invoiceLineNumber}}
      </div>
      <div class="invoice-line__cell">
        
      </div>
      <div class="invoice-line__cell">
        {{discount.description ?? 'Discount'}}
      </div>
      <div class="invoice-line__cell">
        {{formatting.currency(-discount.amount, order.state.currencyCode, CurrencyDisplay.none)}}
      </div>
      <div class="invoice-line__cell">
        
      </div>
      <div class="invoice-line__cell">
        
      </div>
      <div class="invoice-line__cell">

      </div>
      <div class="invoice-line__cell">
        
      </div>
    </div>
  </div>
</template>

<style scoped>
.invoice-line {
  display: contents;
}

.invoice-line__discount {
  grid-column: 1 / -1;
  display: grid;
  grid-template-columns: subgrid;
}

.invoice-line__description {
  grid-column: 3 / 5;
}
</style>